import React from 'react'
import PropTypes from 'prop-types'
import {
  CharacterCounterText,
  Error,
  ErrorAndCounterWrapper,
  Label,
  TextArea,
  TextAreaWithCharacterCounterWrapper,
} from './component.styles'

const TextAreaWithCharacterCounter = ({
  className,
  error,
  label,
  maxChars = 255,
  name,
  onChange,
  placeholder = 'Type here...',
  value = '',
}) => {
  return (
    <TextAreaWithCharacterCounterWrapper className={className}>
      {label && <Label name={label}>{label}</Label>}
      <TextArea
        data-testid={`${name}-textarea-with-character-counter`}
        hasError={!!error}
        maxLength={maxChars}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
      />
      <ErrorAndCounterWrapper>
        <Error>{error}</Error>
        <CharacterCounterText>
          {value.length}/{maxChars}
        </CharacterCounterText>
      </ErrorAndCounterWrapper>
    </TextAreaWithCharacterCounterWrapper>
  )
}

TextAreaWithCharacterCounter.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  handler: PropTypes.func,
  label: PropTypes.string,
  maxChars: PropTypes.number,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
}

export default TextAreaWithCharacterCounter
